import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import httpClient from "../Api/axios";

const UserProfile = () => {
    const { userId } = useParams(); // Grabs the ID from the URL
    const [user, setUser] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchUserData = async () => {
            try {
                // Calls the existing @GetMapping("/{signUpId}") in your SignUpController
                const res = await httpClient.get(`/api/v1/signups/${userId}`);
                setUser(res.data);
            } catch (err) {
                console.error("Error fetching user profile", err);
            } finally {
                setLoading(false);
            }
        };
        fetchUserData();
    }, [userId]);

    if (loading) return <div style={styles.center}>Loading profile...</div>;
    if (!user) return <div style={styles.center}>User not found.</div>;

    return (
        <div style={styles.container}>
            <div style={styles.card}>
                <img 
                    src={user.userProfile || "https://via.placeholder.com/150"} 
                    alt={user.userName} 
                    style={styles.avatar} 
                />
                <h2 style={styles.name}>{user.userName}</h2>
                <p style={styles.detail}>{user.collegeName || "Community Member"}</p>
                <div style={styles.infoBox}>
                    <p><strong>Email:</strong> {user.userEmail}</p>
                    <p><strong>Role:</strong> {user.userRole}</p>
                </div>
            </div>
        </div>
    );
};

const styles = {
    container: { backgroundColor: '#000', minHeight: '100vh', display: 'flex', justifyContent: 'center', alignItems: 'center', color: '#fff' },
    card: { backgroundColor: '#111', padding: '2rem', borderRadius: '15px', border: '1px solid #333', textAlign: 'center', width: '350px' },
    avatar: { width: '120px', height: '120px', borderRadius: '50%', marginBottom: '1rem', objectFit: 'cover', border: '2px solid #3b82f6' },
    name: { fontSize: '1.5rem', marginBottom: '0.5rem' },
    detail: { color: '#888', marginBottom: '1.5rem' },
    infoBox: { textAlign: 'left', borderTop: '1px solid #222', paddingTop: '1rem', fontSize: '0.9rem' },
    center: { color: '#fff', textAlign: 'center', marginTop: '50px' }
};

export default UserProfile;